import logger from "../../../utils/logger";
import React, { useState, Fragment } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledTooltip,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { confirmRequestPayment } from "../../../slices/apps/orderSlice";

// Formik & Yup
import * as Yup from "yup";
import { useFormik } from "formik";

const RequestPaymentConfirmModal = ({ id }) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);

  const { confirmRequestPaymentLoading } = useSelector(
    (state) => ({
      confirmRequestPaymentLoading: state.order.confirmRequestPaymentLoading,
    }),
    shallowEqual
  );

  const validation = useFormik({
    initialValues: {
      description: "",
    },
    validationSchema: Yup.object({
      description: Yup.string().required("Lütfen açıklama giriniz."),
    }),
    onSubmit: async (values) => {
      try {
        const payload = {
          id: id,
          description: values.description,
        };

        await dispatch(confirmRequestPayment(payload)).unwrap();
        setModal(false);
      } catch (error) {
        logger.error("Ödeme onay hatası:", error);
      }
    },
  });

  const toggle = () => {
    if (!modal) {
      validation.resetForm();
    }
    setModal(!modal);
  };

  return (
    <Fragment>
      <span
        id={`payment-confirm-top-${id}`}
        style={{
          display: "flex",
          cursor: "pointer",
          padding: "3px",
        }}
        onClick={toggle}
      >
        <i className="ri-money-dollar-circle-line fs-18" />
      </span>

      <UncontrolledTooltip placement="top" target={`payment-confirm-top-${id}`}>
        Ödeme Onayla
      </UncontrolledTooltip>

      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader className="modal-title" toggle={toggle}></ModalHeader>

        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <i className="ri-money-dollar-circle-line display-3 text-primary"></i>
            <div className="mt-2 pt-2 fs-15">
              <h4>Ödemeyi Onayla</h4>
              <p className="text-muted mx-4 mb-4 fs-13">
                Bu hak ediş ödemesini onaylamak istediğinize emin misiniz? Bu
                işlem geri alınamaz.
              </p>
            </div>
          </div>

          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
            autoComplete="off"
          >
            <FormGroup className="mb-3">
              <Label htmlFor="description">Açıklama</Label>
              <Input
                id="description"
                name="description"
                type="textarea"
                rows="3"
                placeholder="Açıklama giriniz..."
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.description}
                invalid={
                  validation.touched.description &&
                  validation.errors.description
                    ? true
                    : false
                }
                style={{ resize: "none" }}
              />
              {validation.touched.description &&
              validation.errors.description ? (
                <FormFeedback type="invalid">
                  {validation.errors.description}
                </FormFeedback>
              ) : null}
            </FormGroup>

            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <Button
                type="button"
                color="danger"
                className="btn-label w-sm"
                onClick={toggle}
              >
                <i className="ri-close-line label-icon align-middle me-2"></i>
                Kapat
              </Button>

              <Button
                type="submit"
                color="primary"
                className="btn-label w-sm"
                disabled={confirmRequestPaymentLoading}
              >
                <i className="ri-check-line label-icon align-middle me-2"></i>
                {confirmRequestPaymentLoading
                  ? "Onaylanıyor..."
                  : "Evet, Onayla!"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default RequestPaymentConfirmModal;
